export default function (name) {
  const nameArray = name.split(' ')
  return nameArray[0][0] + '' + nameArray[1][0]
}
